import axios from 'axios'
import '../Config'

const jwtToken = localStorage.getItem("authorization");

const INSTRUCTOR = 'v1'
const COURSE_API_URL = global.config.backend
const INSTRUCTOR_API_URL = `${COURSE_API_URL}/${INSTRUCTOR}`

class PedidoService {

    create(carrinho) {
        return axios.post(`${INSTRUCTOR_API_URL}/pedido/create`, carrinho, {headers: {'authorization': "Bearer " + jwtToken}});
    }

    get(){
        return axios.get(`${INSTRUCTOR_API_URL}/pedido/get`, {headers: {'authorization': "Bearer " + jwtToken}});
    }

    getById(id){
        return axios.get(`${INSTRUCTOR_API_URL}/pedido/getbyid?id=${id}`, {headers: {'authorization': "Bearer " + jwtToken}});
    }

}

export default new PedidoService()